import Vue from "vue";
import VueI18n from "vue-i18n";

import { Locale } from "./Locale";
import { messages } from "./messages";

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: Locale.English,
    messages,
    // ignore missing messages warnings in PROD, e.g. [vue-i18n] Value of key 'The Email field must be a valid email' is not a string or function !
    silentTranslationWarn: process.env.NODE_ENV === "production"
});
